import { ICellRendererParams } from "@ag-grid-community/core";
import React from "react";
import { QueryBoundary } from "shared/api/QueryBoundary";

export const MaybernTableCellRendererQueryWrapper: React.FC<
  ICellRendererParams & {
    InnerComponent: React.ElementType;
    innerComponentProps: object;
  }
> = ({ InnerComponent, innerComponentProps, ...params }) => (
  <QueryBoundary>
    <InnerComponent {...innerComponentProps} {...params} />
  </QueryBoundary>
);
